import React from 'react';
import PropTypes from 'prop-types';
import timezone from './utils/timezone';
import dateFormat from './utils/dateFormat';

const DateTimeFormat = ({ dateString }) => (
  <div>{`${dateFormat(dateString)} ${timezone()}`}</div>
);

DateTimeFormat.propTypes = {
  dateString: PropTypes.string,
};

DateTimeFormat.defaultProps = {
  dateString: '',
};

export default DateTimeFormat;